import secureLocalStorage from "react-secure-storage";
import { AUTH_TOKEN_STORAGE } from "./storageConfig";



export function storageAuthTokenSave(token: string) {
    secureLocalStorage.setItem(AUTH_TOKEN_STORAGE, token)
}


export function storageAuthTokenGet() {
    return secureLocalStorage.getItem(AUTH_TOKEN_STORAGE)
}

export function storageAuthTokenRemove() {
    secureLocalStorage.removeItem(AUTH_TOKEN_STORAGE)
}
